import {Injectable} from '@angular/core';
import {HttpClient, HttpRequest} from '@angular/common/http';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileV3RestService {
  constructor(private http: HttpClient) {
  }

  private baseUrl(): string {
    return `${environment.eventsApiBase}/v1/files`;
  }

  uploadFile(file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const req = new HttpRequest('POST', this.baseUrl(), formData, {reportProgress: true});
    return this.http.request(req);
  }
}
